import type { CommandResponse } from '@discord/embedded-app-sdk';
import {auth/*, username*/, instanceId, discordSdk/*, initializeSdk*/, setupDiscordSdk, isEmbedded, appendVoiceChannelName, DiscordVoiceChannelInfo} from './utils/initializeSdk';
import {setupParentIframe, triggerJoinGame} from './gamemanager'
import {joinSession} from './activityclient'
import './style.css';

export let finishLogin:any = null;

var sdkOK=true;
var discordChannelInfo:DiscordVoiceChannelInfo | null = null; //Who do we give this info to? The activity client?

window.addEventListener('DOMContentLoaded', function(){ loadSDK(); });

async function loadSDK(access_data:string = ''){

  setupParentIframe();

  try { 
    await setupDiscordSdk();
  } catch( e) {
    sdkOK=false;
    console.log(e);
  }

  if(sdkOK) {
    console.log("Discord SDK is authenticated");
    discordChannelInfo = await appendVoiceChannelName();
  }

  if(auth) {  
    if(access_data){
      auth.access_token = access_data;
    }
    if (!auth.access_token) {
      //throw new Error('Authenticate command failed');
      console.error('Authenticate command failed');
      /*window.isLeader = true;
      triggerJoinGame("", true);*/
      const sso_buttons_wrapper:HTMLElement = document.getElementById("sso_buttons_wrapper") as HTMLElement;
      if(sso_buttons_wrapper){
        sso_buttons_wrapper.removeAttribute("style");
      }
      const waiting_for_room:HTMLElement = document.getElementById("waiting_for_room") as HTMLElement;
      if(waiting_for_room){
        waiting_for_room.style.display = "none";
      }
      const login_button:HTMLAnchorElement = document.getElementById("discord_sso") as HTMLAnchorElement;
      if(login_button){
          //login_button.href = 'https://warmerise.com/sso/discord?redirect=' + encodeURIComponent(document.referrer || window.location.href) + '&redirect_immediately=1';
          login_button.onclick = function(event:any) { event.preventDefault(); window.open('https://warmerise.com/sso/discord?redirect=' + encodeURIComponent(document.referrer || window.location.href) + '&close_immediately=1', '_blank') };

          finishLogin = function(access_data_tmp:string) {
              //continueJoinSession(instanceId, accessToken);
              console.log("finishLogin Event");
              //joinSession(instanceId, auth.access_token);
              loadSDK(access_data_tmp);
          };
      }
    } else {
      try { 
        await joinSession(instanceId, auth.access_token);
      } catch(e:any) {
        console.error(e.message);
        loadSDK();
      }
    }
  } else {
    console.log ("Failed to authenticate");
  }
}